export const startReconcilePoll = (
  tick: () => 'stop' | undefined,
  intervalMs: number,
): (() => void) => {
  const interval = window.setInterval(run, intervalMs);
  document.addEventListener('visibilitychange', run);

  function stop (): void {
    window.clearInterval(interval);
    document.removeEventListener('visibilitychange', run);
  }

  function run (): void {
    if (document.visibilityState === 'hidden') return;
    if (tick() === 'stop') stop();
  }

  return stop;
};
